import styled, {css} from "styled-components";
import { Color } from "../../../../../../themes/definitions/casino777/casino777-colors";
import { styledByTheme } from "../../../../../../themes/architecture/styled-by-theme";

export interface IJackpotWidgetClockBoxProps {
    className?: string;
    forcePCView?: boolean;
    widgetIsMinimized?: boolean;
    widgetWidth?: number;
}

const JackpotWidgetClockDefaultBox = styled.div<IJackpotWidgetClockBoxProps>`
    width: ${({widgetIsMinimized}) => widgetIsMinimized ? "100%" : "26%" };
    text-align: ${({widgetIsMinimized}) => widgetIsMinimized ? "center" : "right" };
    ${({forcePCView}) => !forcePCView && css`
        @media ${({theme}) => theme.mediaQuery.sAndBelow} {
            text-align: center;
            width: 100%;
        }
    `}

    color: ${({theme}) => theme.colors.bodyText};
    font-family: ${({theme}) => theme.components.jackpotWidget.font.clock};

    font-size: ${({widgetWidth, widgetIsMinimized}) => {
        /** For the floating clock shown in game, no need to compute relative (fluid) font-size */
        if (!widgetWidth) {
            return widgetIsMinimized ? "15px" : "30px";
        }
        if (widgetIsMinimized) {
            /** In minimized view at a widget width of 375px, the amount should be of font-size 9px */
            return widgetWidth * 15 / 375 + "px";
        }
        /** In desktop view at a widget width of 468px, the amount should be of font-size 15px */
        return widgetWidth * 30 / 468 + "px";
    }};
    ${({forcePCView, widgetWidth, theme}) => !forcePCView ? css`
        @media ${theme.mediaQuery.sAndBelow} {
            /** In mobile view at a widget width of 131px, the amount should be of font-size 9px */
            font-size: ${widgetWidth ? (widgetWidth * 15 / 131 + "px") : "15px"};
        }
    ` : null}
`;

const JackpotWidgetClockCasino777Box = styled(JackpotWidgetClockDefaultBox)`
    color: ${Color.blackTeal};
`;

export const JackpotWidgetClockBox = styledByTheme(JackpotWidgetClockDefaultBox).forCasino777(JackpotWidgetClockCasino777Box).apply();
